import React from 'react'
import loadable from '@loadable/component'

import ConvenienceMessage from '../../ConvenienceMessage/ConvenienceMessage'
import AvailabilityMessage from '../../AvailabilityMessage/AvailabilityMessage'

const CountDownTimer = loadable(() =>
  import(/* webpackChunkName: "count-down-timer" */ '../CountDownTimer/CountDownTimer')
)

export const formatAvailabilityMessage = (availabilityMessage, store) => {
  // Revisit this as there may be a better implementation
  if (!availabilityMessage) return ''
  return availabilityMessage.replace(store, `<strong>${store}</strong>`)
}

export const CollectionMessage = ({
  collectionIcon,
  collectionMessage,
  collectionStore,
  collectionCutoff,
  collectionStockCode,
  convenienceStore
}) => {
  const convenienceMessage = convenienceStore && convenienceStore.storeprepay && convenienceStore.storeprepay === 6
  const collectToday = () => collectionCutoff && collectionStockCode?.split('|')[0] === 'c2'
  return (
    <>
      <AvailabilityMessage
        icon={collectionIcon}
        message={formatAvailabilityMessage(collectionMessage, collectionStore)}
        store={collectionStore}
      />
      {convenienceMessage && <ConvenienceMessage />}
      {collectToday() && new Date().getDay() !== 0 && <CountDownTimer collectionCutoff={collectionCutoff} />}
    </>
  )
}
